module.exports = __webpack_public_path__ + "img/cocopay-logo-colored.32f41d22.png";